module.exports = __webpack_public_path__ + "static/media/03.99492839.jpg";